<template>
    <div class="de-rank-list">
        <rank class="item" v-for="(item, index) in rankList" 
        :key="index" 
        :rank-item="item"
        :margin="margin"
        :barWidth="barWidth"></rank>
    </div>
</template>

<script>
import Rank from '../rank';

export default {
    name: 'de-rank-list',
    components: {
        Rank
    },
    props: ['rankList', 'margin', 'barWidth'],
    data() {
        return {
            
        }
    }
}
</script>

<style lang="less" scoped>
.de-rank-list {
    display: flex;
    flex-wrap: wrap;
    .item:nth-child(even) {
        padding-left: 22px;
    }
    .item:nth-child(odd) {
        padding-right: 22px;
    }
    .item:last-child {
        padding-bottom: 16px;
    }
}
</style>